import { STATUS_TYPE } from '../../../enum';


export interface TrainingVideoResponse {
  status: string;
  message: string;
  data: TrainingVideoItem[];
}

export interface TrainingVideoItem {
  id: number,
  title: string,
  description: string,
  position: number,
  type: string,
  link: string,
  status: number,
  created_at: string,
  updated_at: string,
  user_id: number,
  filename: string,
  thumb_name: string,
  thumb_link: string,
  tag: string,
  migrate_s3: number
}

export interface TrainingVideoSearchResult {
  title: string;
  code: string;
  data: TrainingVideoItem[];
}

interface InitialState {
  data: TrainingVideoItem[];
  searchResult: TrainingVideoSearchResult[];
  searchText: string,
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}


export const initialState: InitialState = {
  data: [],
  searchResult: [],
  searchText: '',
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
